<h1>Gestion des Intervenants</h1>
<pannel [title]="'Recherche'" [expandable]="true" [folded]="true">
	<intervenants-filters
		(filterRequest)="filters$.next($event)"
		>
	</intervenants-filters>
</pannel>
<pannel [title]="'Liste des intervenants'">
	<intervenants-table
		[filtersSubject]="filters$"
		>
	</intervenants-table>
</pannel>